import apiClient from '../../api/apiClient';
import { Role } from '../users/usersSlice';

const rolesService = {
  getRoles: async (): Promise<Role[]> => {
    try {
      const response = await apiClient.get('/roles');
      
      if (!Array.isArray(response)) {
        return [];
      }
      
      return response;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return [];
    }
  }
};

export default rolesService;